export const errors = {
    100: 'XML parsing error.',

    200: 'Trafficking error. Video player received an Ad type that it was not expecting and/or cannot display.',

    300: 'General Wrapper error.',
    301: 'Timeout of VAST URI provided in Wrapper element, or of VAST URI provided in a subsequent Wrapper element. (URI was either unavailable or reached a timeout as defined by the video player.)',

    302: 'Wrapper limit reached, as defined by the video player. Too many Wrapper responses have been received with no InLine response.',
    303: 'No Ads VAST response after one or more Wrappers.',

    401: 'File not found. Unable to find Linear/MediaFile from URI.',
    402: 'Timeout of MediaFile URI.',
    403: 'Couldn’t find MediaFile that is supported by this video player, based on the attributes of the MediaFile element.',
    405: 'Problem displaying MediaFile. Video player found a MediaFile with supported type but couldn’t display it. ',
    410: 'Verification unit in the Verification node was not executed.',

    600: 'General CompanionAds error.',

    900: 'Undefined Error.',
    901: 'General VPAID error.',

    1000: 'Media file was interrupted by timeout',
    1001: 'VPAID tag error',
};

// AD_LOADING_ERROR: 'JS media file is not responding',
// FILE_LOADING_ERROR: 'File or path is invalid',
// AD_START_ERROR: 'Ad start error',
// AD_STOP_ERROR: 'Ad stop error',
